import React, { forwardRef, useState } from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { BoxClass, OneNode } from '../../../helper/classes'
import { DragSource } from 'react-dnd'
import * as shortid from 'shortid'
import { Button, Card, Popover, Tag, Tooltip } from '@blueprintjs/core'
import { globalOnDemandVars } from '../../../helper/context'
import { Spreadsheet } from '../../list/spreadsheet/classes'
import DragDropContextHOC from '../../../helper/DragDropContext'
import { uniqueId } from 'lodash'
import { createSpreadsheet } from '../../../backend/spreadsheet/createData'
import { OverlayProps } from '../../../helper/configs'
import onboardingGIF from '../../../../assets/images/spreadsheet2.gif'

const externalNodeType = 'toSortableTree'
const externalNodeSpec = {
  beginDrag: (componentProps) => ({
    node: { ...componentProps.node },
    parentNode: null,
    path: [],
    rootPath: { length: -1 },
    treeIndex: 0,
    treeId: uniqueId()

  }),
  endDrag: (props, monitor) => {
    if (process.env.NODE_ENV !== 'production') {
      console.tron.display({
        name: 'endDrag in spreadsheet node',
        value: {
          didDrop: monitor.didDrop(),
          getDropResult: monitor.getDropResult(),
          props
        }
        // , important: true
      })
    }
    if (monitor.didDrop()) {
      const spreadsheetId = props.node.spreadsheetId
      const spreadsheet = new Spreadsheet(spreadsheetId)
      globalOnDemandVars.spreadsheets()[spreadsheetId] = spreadsheet
      if (!globalOnDemandVars.isPixelMode()) {
        createSpreadsheet(spreadsheetId, spreadsheet).then(() => {
          setSpreadsheetNodeOutside(null)
        })
      } else {
        setSpreadsheetNodeOutside(null)
      }
    }
  }
}
const externalNodeCollect = (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  connectDragPreview: connect.dragPreview(),
  isDragging: monitor.isDragging()
  // didDrop: monitor.didDrop()
})

class InnerExternalNodeBaseComponent extends React.Component {
  render () {
    const { connectDragSource, node } = this.props
    return connectDragSource(
      <div>
        <Tag icon='th' intent='success' minimal large interactive css={css`cursor: grab !important;`}>
          Spreadsheet Node
        </Tag>
      </div>, { dragEffect: 'copy' }
    )
  }
}

const ExternalNodeBaseComponent = DragSource(
  externalNodeType, externalNodeSpec, externalNodeCollect
)(InnerExternalNodeBaseComponent)

const generatingSpreadsheetNode = () => {
  const nodeBase = new OneNode()
  nodeBase.isSpreadsheet = true
  const spreadsheetId = shortid.generate()
  nodeBase.spreadsheetId = spreadsheetId

  return <div>
    <Popover interactionKind={'click'} content={(<div css={css`text-align: center;`}>
      <img src={onboardingGIF} alt='' />
      Drag it and drop it on the tree like normal nodes
    </div>)} {...OverlayProps} intent='success'><Button fill icon={'help'} text={'Help'} /></Popover>
    <br /><br />
    <ExternalNodeBaseComponent node={nodeBase} />
  </div>
}

let setSpreadsheetNodeOutside
function InnerSpreadsheetAddOn () {
  const [spreadsheetNode, setSpreadsheetNode] = useState(null)
  setSpreadsheetNodeOutside = setSpreadsheetNode

  return (
    <div css={css`text-align: center;`}>
      <br /><br />
      {spreadsheetNode || <Button
        text='generate Spreadsheet' intent='success' onClick={() => {
          setSpreadsheetNode(generatingSpreadsheetNode())
        }}
      />}

    </div>
  )
}

// eslint-disable-next-line no-func-assign
InnerSpreadsheetAddOn = forwardRef(InnerSpreadsheetAddOn)

const SpreadsheetAddOn = DragDropContextHOC(InnerSpreadsheetAddOn)

const SpreadsheetAddOnBoxClass = new BoxClass(SpreadsheetAddOn, 'Spreadsheet', null, 2, { order: 9 })

export default SpreadsheetAddOnBoxClass
